import { Component, Vue } from 'vue-property-decorator';

import template from './delete-company.vue';
import { Action } from '@/store';
import { ModalState } from '@/definitions';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class DeleteCompany extends Vue {
  companyName: string = '';

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  async deleteCompany() {
    if (this.companyName === this.modal.props.company) {
      try {
        await apiService.deleteAdminCompany(this.modal.props.companyId);
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.company.delete_success', type: 'success' });
        this.closeModal();
      } catch (e) {
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.company.delete_error', type: 'danger' });
      }
    }
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}